import React from 'react';
import { useParams } from 'react-router-dom';
import PageHeader from './PageHeader';
import FilterSection from './FilterSection';
import ProductSection from './ProductSection';
import FeatureSection from './FeatureSection';
import FAQSection from './FAQSection';
import styles from '../styles/ProductSeriesPage.module.css';

const ProductSeriesPage = () => {
  const { category } = useParams(); // 获取路由参数：mirrors 或 products

  const mirrorProducts = [
    { name: 'ChatGPT镜像账户', price: '39.99', icon: 'fas fa-microchip', id: 'chatgpt-mirror' },
    { name: 'Claude AI镜像账户', price: '49.99', icon: 'fas fa-brain', id: 'claude-mirror' },
    { name: 'Midjourney镜像账户', price: '59.99', icon: 'fas fa-robot', id: 'midjourney-mirror' },
    { name: 'Copilot镜像账户', price: '45.99', icon: 'fas fa-code', id: 'copilot-mirror' },
    { name: 'DALL-E镜像账户', price: '42.99', icon: 'fas fa-paint-brush', id: 'dalle-mirror' },
    { name: 'Bard AI镜像账户', price: '38.99', icon: 'fas fa-database', id: 'bard-mirror' },
    { name: 'Stable Diffusion账户', price: '52.99', icon: 'fas fa-chart-line', id: 'stable-diffusion-mirror' },
    { name: 'AI Suite综合账户', price: '89.99', icon: 'fas fa-lightbulb', id: 'ai-suite-mirror' },
  ];

  const finishedProducts = [
    { name: '网站E成品号', price: '24.99', icon: 'fas fa-database', id: 'website-e-finished' },
    { name: '网站F成品号', price: '29.99', icon: 'fas fa-server', id: 'website-f-finished' },
    { name: '网站G成品号', price: '19.99', icon: 'fas fa-network-wired', id: 'website-g-finished' },
    { name: '网站H成品号', price: '15.99', icon: 'fas fa-code', id: 'website-h-finished' },
  ];

  const features = [
    { title: '安全可靠', desc: '所有账户均经过严格安全检测，确保您的使用体验安全无忧，提供7x24小时技术支持服务。', icon: 'fas fa-shield-alt' },
    { title: '即时交付', desc: '付款成功后系统自动即时发货，无需等待，立即获取账户信息，开始您的AI之旅。', icon: 'fas fa-bolt' },
    { title: '稳定可用', desc: '我们的镜像账户采用先进技术部署，确保长期稳定可用，定期维护更新。', icon: 'fas fa-sync-alt' },
    { title: '专业服务', desc: '专业客服团队为您提供一对一咨询服务，解答疑问，提供技术支持和使用指导。', icon: 'fas fa-headset' },
  ];

  const isMirrors = category === 'all-mirrors';
  const products = isMirrors ? mirrorProducts : finishedProducts;
  const title = isMirrors ? 'AI科技镜像账户' : 'AI科技成品号';
  const description = '我们提供安全、快速且实惠的AI科技服务，覆盖多种网站和应用，满足您的各种需求。';

  return (
    <>
      <PageHeader
        title={title}
        description={description}
        breadcrumbs={[
          { label: '首页', path: '/' },
          { label: isMirrors ? '镜像账户' : '成品号' },
        ]}
      />
      <FilterSection />
      <ProductSection id="all-mirrors" title={isMirrors ? '镜像账户' : '成品号'} products={products} />
      <FeatureSection id="features" title="我们的优势" features={features} />
      <FAQSection />
    </>
  );
};

export default ProductSeriesPage;